export interface ICommunicationType {
    name: string;
    code: string;
}

export class CommunicationType implements ICommunicationType{
    name: string;
    code: string;
}